import React, { useState } from "react";
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './slider.css'

const MissionSliders = (props) => {
    const [modalOpen, setModalOpen] = useState(false);
    const [selectedImage, setSelectedImage] = useState("");

    const openModal = (image) => {
        setSelectedImage(image);
        setModalOpen(true);
    };

    const closeModal = () => {
        setModalOpen(false);
    };

      const imagesToDisplay = props.mission && props.mission.instagram && props.mission.instagram.length > 0
        ? props.mission.instagram.map((img, idx) => ({ id: idx.toString(), imag: img, title: '', subtitle: '' }))
        : '';



    const settings = {
        dots: false,
        arrows: false,
        slidesToShow: 6,
        slidesToScroll: 1,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 0,
        speed: 5000,
        cssEase: 'linear',
        pauseOnHover: true,
        responsive: [
            {
                breakpoint: 1399,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 1199,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 575,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            }
        ]
    };

    return (
        <section className={props.hclass}>
            <div className="container-fluid mt-5">
                <div className="instagram-wrap">
                    <div className="instagram-slider">
                        <Slider {...settings}>
                            {imagesToDisplay.map((item) => (
                                <div className="instagram-card" key={item.id}>
                                    <div className="image">
                                        <div
                                            className="fancybox"
                                            data-fancybox-group="gall-1"
                                            onClick={() => openModal(item.imag)}
                                            style={{ cursor: 'pointer' }}
                                        >
                                            <img
                                                src={item.imag}
                                                alt={`Instagram ${item.id}`}
                                                className="img img-responsive"
                                            />
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </Slider>
                    </div>
                </div>
            </div>

            {modalOpen && (
                <div className="modal" onClick={closeModal}>
                    <div className="modal-wrap">
                        <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                            <span className="close" onClick={closeModal}>
                                &times;
                            </span>
                            <img src={selectedImage} alt="Modal" />
                        </div>
                    </div>
                </div>
            )}
        </section>
    );
};

export default MissionSliders;